exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".character-counter[data-v-163e370a]{text-align:right}.form-control[data-v-163e370a]:focus{border-color:#007bff;-webkit-box-shadow:0 0 0 .2rem rgba(0,123,255,.25);box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.btn-primary[data-v-163e370a]{min-width:100px}.btn-primary[data-v-163e370a]:disabled{opacity:.6;cursor:not-allowed}@media (max-width:576px){.d-flex[data-v-163e370a]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.btn-primary[data-v-163e370a]{margin-top:.5rem;width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-163e370a","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Assets/components/AiAgents/FaqAgent/components/QuestionInput.vue
// module id = 2307
// module chunks = 1